import React from 'react'
import classNames from 'classnames'
import styles from './CcqGroupCard.module.scss'

// Deliberately not a spinner or an arc, so AI work can't be mistaken for the record check.

export const CcqAiIndicator: React.FC = () => <i className={classNames('bi bi-stars flex-shrink-0', styles.aiIndicator)} aria-hidden='true' />
